import React, { Fragment } from 'react';
import { Link } from 'gatsby';
import uniqid from 'uniqid';

import Arrow from '../../images/icons/arrow.svg';

const Pagination = ({
  pageCount,
  prevPageText,
  nextPageText,
  pageText,
  current,
  urlPrefix,
  hasButtons,
  onPageClick,
  onNextClick,
  onPreviousClick,
}) => {
  const pageLink = `${urlPrefix}`;

  const nextPageLink = `${pageLink}/page/${current + 1}`;
  const prevPageLink = current - 1 === 1 ? pageLink : `${pageLink}/page/${current - 1}`;

  let pages = [];

  for (let i = 1; i <= pageCount; i++) {
    const pageString = (
      <Fragment>
        <span className="pagination__page-text">{pageText} </span>
        {i}
      </Fragment>
    );

    if (current === i) {
      pages = [
        ...pages,
        <span className="pagination__page pagination__page--current" key={uniqid()}>
          {pageString}
        </span>,
      ];
    } else {
      let thisPageLink = pageLink;

      if (i > 1) {
        thisPageLink = `${pageLink}/page/${i}`;
      }

      if (hasButtons) {
        pages = [
          ...pages,
          <button className="pagination__page" onClick={() => onPageClick(i)} key={uniqid()}>
            {pageString}
          </button>,
        ];
      } else {
        pages = [
          ...pages,
          <Link className="pagination__page" to={thisPageLink} key={uniqid()}>
            {pageString}
          </Link>,
        ];
      }
    }
  }

  return (
    <section className="pagination">
      <div className="pagination__inner">
        {current !== 1 && (
          <Fragment>
            {!hasButtons && (
              <Link className="pagination__previous" to={prevPageLink}>
                <Arrow className="pagination__previous-icon" />
                {prevPageText}
                <span className="pagination__page-text">{pageText}</span>
              </Link>
            )}
            {hasButtons && (
              <button className="pagination__previous" onClick={onPreviousClick}>
                <Arrow className="pagination__previous-icon" />
                {prevPageText}
                <span className="pagination__page-text">{pageText}</span>
              </button>
            )}
          </Fragment>
        )}
        {current !== pageCount && (
          <Fragment>
            {!hasButtons && (
              <Link className="pagination__next" to={nextPageLink}>
                <Arrow className="pagination__next-icon" />
                {nextPageText}
                <span className="pagination__page-text">{pageText}</span>
              </Link>
            )}
            {hasButtons && (
              <button className="pagination__next" onClick={onNextClick}>
                <Arrow className="pagination__next-icon" />
                {nextPageText}
                <span className="pagination__page-text">{pageText}</span>
              </button>
            )}
          </Fragment>
        )}
        <div className="pagination__pages">{pages}</div>
      </div>
    </section>
  );
};

Pagination.defaultProps = {
  pageText: 'Page',
  nextPageText: 'Next',
  prevPageText: 'Previous',
  hasButtons: false,
  onPageClick: null,
  onNextClick: null,
  onPreviousClick: null,
};

export default Pagination;
